import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Button, Icon, InputNumber, Modal, notification } from "antd";

import { isSuperUser } from "../../../../../utils/is-superuser";
import api from "../../../../../services/api";
import "./styles.css";

export const NotaFiscalParcela = (props) => {
  const { idParcela, initialValue, data = {} } = props;

  const { valor_pago, status_conciliado, status_pago } = data;

  const [isEditing, setEditing] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [numberNF, setNumberNF] = useState(initialValue);
  const [isConciliado, setConciliado] = useState(
    status_conciliado === "CONCILIADO"
  );

  const ref = useRef();

  const toggleEditing = () => setEditing(!isEditing);

  const handleSave = () => {
    setSaving(true);

    const numeroNF = ref.current.inputNumberRef.state.value;

    api
      .post(`/contratos/parcela/${idParcela}/nf/`, {
        numero_nf: numeroNF,
        status_conciliado: "NAO CONCILIADO",
        status_pago,
        valor_pago,
      })
      .then(() => {
        toggleEditing();
        setNumberNF(numeroNF);
        setConciliado(false);

        notification.success({
          message: "Nota fiscal atualizada com sucesso.",
        });
      })
      .catch(() => {
        notification.error({
          message: "Ocorreu um erro ao atualizar a nota fiscal.",
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const askConciliar = () =>
    Modal.confirm({
      content: `${isConciliado ? "Desconciliar" : "Conciliar"} nota fiscal?`,
      onCancel: () => null,
      onOk() {
        return api
          .post(`/contratos/parcela/${idParcela}/nf/`, {
            numero_nf: numberNF,
            status_conciliado: isConciliado ? "NAO CONCILIADO" : "CONCILIADO",
            status_pago,
            valor_pago,
          })
          .then(() => {
            notification.success({
              message: `Nota fiscal ${
                isConciliado ? "desconciliada" : "conciliada"
              }.`,
            });
            setConciliado(!isConciliado);
          })
          .catch(() => {
            notification.error({
              message: "Ocorreu um erro ao atualizar a nota fiscal.",
            });
          })
          .finally(() => {
            setSaving(false);
          });
      },
    });

  const isAdmin = isSuperUser();

  return (
    <div className="nota_fiscal__container">
      <span>{numberNF || "---"}</span>
      {isAdmin && (
        <Button type="primary" ghost size="small" onClick={toggleEditing}>
          <Icon type="edit" />
        </Button>
      )}
      {!!numberNF && isAdmin && (
        <div>
          {isConciliado && (
            <Button type="danger" ghost size="small" onClick={askConciliar}>
              DESCONCILIAR
            </Button>
          )}
          {!isConciliado && (
            <Button type="ghost" size="small" onClick={askConciliar}>
              CONCILIAR
            </Button>
          )}
        </div>
      )}
      <Modal
        visible={isEditing}
        title="Número Nota Fiscal"
        okText="Salvar"
        cancelText="Cancelar"
        onCancel={toggleEditing}
        confirmLoading={isSaving}
        onOk={handleSave}
        cancelButtonProps={{
          disabled: isSaving,
        }}
      >
        <label htmlFor="value">Insira o número da nota:</label>
        <div style={{ marginTop: "5px" }}>
          {isEditing && (
            <InputNumber
              ref={ref}
              type="number"
              defaultValue={numberNF}
              style={{ width: "100%" }}
              id="value"
              name="value"
              autoFocus
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

NotaFiscalParcela.propTypes = {
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idParcela: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.shape({
    valor_pago: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status_conciliado: PropTypes.string,
    status_pago: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/NotaFiscal/index.jsx